module.exports = __webpack_public_path__ + "static/IcoMoon-Free-38e41af08b6215babc05c4f3161cb01d.woff";